import {
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";

import NatureIcon from "@mui/icons-material/Nature";
import YardIcon from "@mui/icons-material/Yard";

function Morphology({ plant }) {
  if (!plant?.morphological_characters) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 5,
        p: {
          xs: 3,
          md: 4,
        },
        borderRadius: 5,
        background:
          "linear-gradient(135deg,#FFFFFF,#F8FBFC)",
        border: "1px solid #E4EDF2",
        boxShadow: "0 10px 30px rgba(11,60,93,.08)",
      }}
    >
      {/* Heading */}

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        mb={3}
      >
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: "50%",
            bgcolor: "#EEF5FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NatureIcon
            sx={{
              color: "#0B3C5D",
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            Morphological Characters
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              fontSize: 15,
            }}
          >
            Botanical morphology and field identification features
          </Typography>
        </Box>
      </Stack>

      {/* Accent Line */}

      <Box
        sx={{
          width: 90,
          height: 4,
          bgcolor: "#43A047",
          borderRadius: 10,
          mb: 3,
        }}
      />

      {/* Content */}

      <Typography
        sx={{
          textAlign: "justify",
          lineHeight: 2.1,
          color: "#555",
          fontSize: {
            xs: "1rem",
            md: "1.05rem",
          },
        }}
      >
        {plant.morphological_characters}
      </Typography>

      {/* Note */}

      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 4,
          bgcolor: "#F5FAF7",
          borderLeft: "5px solid #43A047",
          display: "flex",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        <YardIcon
          sx={{
            color: "#2E7D32",
            mt: 0.3,
          }}
        />

        <Typography
          sx={{
            color: "#555",
            lineHeight: 1.9,
          }}
        >
          <strong style={{ color: "#0B3C5D" }}>
            Botanical Note:
          </strong>{" "}
          The morphological description presented here is based
          on standard botanical literature and is intended for
          plant identification, taxonomic studies, herbarium
          documentation, and field-level verification of the
          species.
        </Typography>
      </Box>
    </Paper>
  );
}

export default Morphology;